import React from 'react'
import {Container} from 'react-bootstrap'
import { useHistory } from 'react-router'
import CompHeader from './comp_header'
import './style.css'

export default function Header() {
    const history = useHistory()

    const clickHandler = () => {
        history.push("/referral")
    }

    const pointHandler = () => {
        history.push("/point")
    }

    return (
        <Container className="componenet-page-users">
            <div className="component-user">
                <img className="akun-user" src="asset/users/user.svg" alt="user" />
                <div className="card-user">
                    <p className="user-name">Muhammad Rifqi Mubarak</p> 
                    <div className="points-user">
                        <CompHeader cHeader="comp-header" span="Poin" cUsers="card-poin" cIcon="img-poin" cText="numbers" text="30" />
                        <CompHeader cHeader="comp-header" span="Kupon" cUsers="card-poin" cIcon="img-poin" cText="numbers" text="6" />
                        <CompHeader cHeader="comp-header" span="Level" cUsers="poin-user" cIcon="img-medali" src="asset/users/medali.svg" alt="medali" onClick={pointHandler} cText="text" text="Sultan" />
                        <CompHeader cHeader="comp-header" span="ID Reseller" cUsers="poin-user" onClick={clickHandler} cIcon="img-file" src="asset/users/file-copy.svg" alt="file-copy" cText="text" text="muhammad.p2w" />
                        <CompHeader cHeader="comp-nonborder" cUsers="poin-user" cIcon="img-plus" src="asset/users/plus.svg" alt="file-copy" cText="text-plus" text="Ajak Teman" />
                    </div>
                </div>
            </div>
        </Container>
    )
}
